import { createAction } from '@ngrx/store';
export function createSourcedAction(type, config) {
    const actionCreator = config
        ? createAction(type, config)
        : createAction(type);
    const sourcedActionCreator = Object.defineProperty((sourceOrProps, props) => {
        if (typeof sourceOrProps === 'string') {
            const action = actionCreator(props);
            const source = sourceOrProps;
            Object.defineProperty(action, 'typeWithoutSource', {
                value: type,
                writable: false,
            });
            Object.defineProperty(action, 'type', {
                value: `[${source}] ${type}`,
                writable: false,
            });
            return action;
        }
        else {
            const props = sourceOrProps;
            return actionCreator(props);
        }
    }, 'type', { value: type, writable: false });
    return sourcedActionCreator;
}
export const isSourcedAction = (action) => 'type' in action && 'typeWithoutSource' in action;
// models.ts
export const arraysAreNotAllowedMsg = 'arrays are not allowed in action creators';
export const typePropertyIsNotAllowedMsg = 'type property is not allowed in action creators';
export const emptyObjectsAreNotAllowedMsg = 'empty objects are not allowed in action creators';
